export const IngredientsCheck = {
  bindings: {
    ingredient: '<',
    checked: '<',
  },

  template: `
    <div
      class="checklist-item py-1 py-md-0"
      ng-class="{ 'checked': $ctrl.checked }">
      <i class="fa fa-li fa-check-square-o mt-1 mt-md-0"
        ng-class="$ctrl.checked ? 'fa-check-square-o' : 'fa-square-o'">
      </i>
      <span>{{ $ctrl.ingredient.displayString }}</span>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Ingredients/IngredientsCheck.js